import * as videokubeUtils from 'videokube-front-library/dist/videokubeUtils';


export const getKeyWithPrefixIfExistant = videokubeUtils.getKeyWithPrefixIfExistant;
